<template>
  <header :class="{ sticky: isSticky }" style="background-color: #1f2746;color:white">
    <!-- v-click-outside="onClickOutside"> -->

    <div class="container">
      <nav class="navbar navbar-expand-lg px-sm-3 px-0 navbar-fixed-top">
        <a :href="portalUrl">
          <v-img :src="require('@/assets/images/image.png')" class="portal_logo" @click="$router.push('/')" />
        </a>
        <v-spacer></v-spacer>

        <!-- <ul class="rd-navbar-nav d-flex flex-row align-center mb-0">
                  <li class="me-4 fw-bold px-5"><a>HOME</a></li>
                  <li class="me-4 fw-bold px-5"><a>ABOUT</a>
                  </li>
                  <li class="me-4 fw-bold px-5"><a>BLOG</a>
                  </li>
                  <li class="me-4 fw-bold px-5"><a>PAGES</a>
                  </li>
                  <li class="fw-bold"><a>CONTACTS</a></li>
                </ul> -->

        <div v-if="headerMenus.includes('country')" class="d-flex align-center me-sm-3 me-1">
          <v-menu v-model="isMenuCurrency" location="bottom" :disabled="countryDisabled">
            <template v-slot:activator="{ props }">
              <v-card class="shadow-none bg-transparent d-flex" v-bind="props" style="cursor: pointer">
                <div class="d-flex align-center">
                  <div>
                    <v-img :src="display_flagLogo" width="30px" height="30px" style="border-radius: 50%" />
                  </div>

                  <span v-if="currentCountry" class="ps-1 currency-text textColor f-size-15 fw-600 text-uppercase">
                    {{ currentCountry.currency }} - {{ displayLanguage }}
                  </span>
                </div>

                <v-list-item-icon v-if="countryOptions.length > 1" class="d-sm-block d-none">
                  <span>
                    <v-icon size="30" :class="{ 'rotate-icon': isMenuCurrency }">mdi-menu-down</v-icon>
                  </span>
                </v-list-item-icon>
              </v-card>
            </template>
            <v-list style="cursor: pointer" v-if="countryOptions.length > 1">
              <div v-for="(country, index) of filteredCountryOptions" :key="index">
                <v-list-item class="hoverList" v-if="country.country_code !== countyIsocode">
                  <div>
                    <a :href="userqueryIso !== country.country_code ? country.portal_url : `${country.portal_url}/?ref=web&redirect=false`" style="text-decoration: none;">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="country.flag_logo" width="30px" height="30px" style="border-radius: 50%" />
                        </div>
                        <span class="ps-1 f-size-15">{{ country.currency }}</span>
                      </div>
                    </a>
                  </div>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </div>

        <!-- <div v-if="!headerMenus.includes('language')" class="d-flex align-center me-sm-3 me-1">
          <v-menu v-model="isMenulanguage" location="bottom center">
            <template v-slot:activator="{ props }">
              <v-card class="shadow-none bg-transparent d-flex" v-bind="props" style="cursor: pointer">
                <div class="d-flex align-center">
                  <div class="currency-text">
                    <v-img :src="require('@/assets/icons/language_icon.png')" width="22px" style="filter: brightness(0) invert(1);"/>
                  </div>

                  <span class="f-size-15 fw-600 ps-1 text-uppercase">{{
                    displayLanguage
                  }}</span>
                </div>


                <v-list-item-icon v-if="languageOptions.length > 1" class="d-sm-block d-none">
                  <span>
                    <v-icon size="30" :class="{ 'rotate-icon': isMenulanguage }">mdi-menu-down</v-icon>
                  </span>
                </v-list-item-icon>
              </v-card>
            </template>

            <v-card class="d-flex flex-wrap p-2 rounded-4" style="cursor: pointer; max-width: 440px;" v-if="languageOptions.length > 1">
              <div class="hoverList px-3 py-2 rounded-2 m-1" :class="{'disabledLang': index == 0 }"
                v-for="(lang, index) in sortedLanguageOptions" :key="index">
                <div class="d-flex align-center" @click="changeLocale(lang.code)">
                  <span class="ps-1 f-size-15" :style="{ color: (index == 0 ? '#94c20e' : '') }">
                    <span class="text-uppercase fw-500">{{ lang.code }}</span>
                    <span class="fw-400"> - {{ lang.name }}</span>
                  </span>
                </div>
              </div>
            </v-card>
          </v-menu>
        </div> -->

        <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" :aria-expanded="!isCollapsed" aria-label="Toggle navigation" @click="toggleNavbar" >
          <span class="navbar-toggler-icon" style="filter: brightness(0) invert(1);"></span>
        </button> -->
        <div class="mob_Hd">
        <button class="ms-5" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"><span class="navbar-toggler-icon" style="filter: brightness(0) invert(1);"></span></button>

          <div class="offcanvas offcanvas-end offblue" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
          <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel"><v-img :src="require('@/assets/images/image.png')" class="portal_logo1" width="30px" height="30px" /></h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body">
            <div class="accordion accordion-flush" id="accordionFlushExample">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    Support
                  </button>
                </h2>
                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <v-list style="cursor: pointer;background-color:#161b31; width: 267px; margin-left: 20px;">
                    <v-list-item class="hoverList1">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/email_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <a :href="'mailto:' + emailPortal" class="text-decoration-none">
                          <span class="ps-1 text-color" style="font-size: 14px;">{{
                            emailPortal
                          }}</span>
                        </a>
                      </div>
                    </v-list-item>
                    <v-list-item class="hoverList1" @click="toggleTawkToChat()"
                      v-if="!this.headerMenus.includes('chatsupportlink')">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/chat_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 text-color" style="font-size: 14px;">Chat Support</span>
                      </div>
                    </v-list-item>
                  </v-list>  
                </div>
              </div>
              <div class="accr_t mt-5">My Trips</div>
              <div class="accr_t mt-5">Sign In</div>
            </div>
          </div>
          </div>
        </div>
        <div class="container-fluid setSize">
          <div class="collapse navbar-collapse" :class="{ show: !isCollapsed }" ref="navbarCollapse" id="navbarSupportedContent">
            <ul class="navbar-nav my-2 my-lg-0">
              <li v-if="headerMenus.includes('email')" class="nav-item dropdown d-flex justify-end align-center me-sm-3 me-0">
                <v-menu v-model="isMenuHelp" location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-card class="shadow-none d-flex textColor" @click="showForm = false" v-bind="props" style="cursor: pointer;background-color:rgb(31 39 70);">
                      <div class="d-flex align-center">
                        <!-- <div>
                          <v-img :src="require('@/assets/icons/helpbox.png')" width="25px" class="iconColor"/>
                        </div> -->

                        <span class="ps-1 textColor" style="font-size: 15px; font-weight: 600;">Support</span>

                      </div>

                      <v-list-item-icon>
                        <span>{{ console.log(isMenuHelp,'isMenuhelpppp') }}
                          <v-icon size="30" class="textColor" style="height:37px;">mdi-menu-down</v-icon>
                        </span>
                      </v-list-item-icon>
                    </v-card>
                  </template>
                  <v-list style="cursor: pointer;background-color:#161b31;top:30px;">
                    <v-list-item class="hoverList1">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/email_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <a :href="'mailto:' + emailPortal" class="text-decoration-none">
                          <span class="ps-1 text-color" style="font-size: 14px;">{{
                            emailPortal
                          }}</span>
                        </a>
                      </div>
                    </v-list-item>
                    <v-list-item class="hoverList1" @click="toggleTawkToChat()"
                      v-if="this.headerMenus.includes('chatsupportlink')">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/chat_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 text-color" style="font-size: 14px;">Chat Support</span>
                      </div>
                    </v-list-item>
                    <!-- <v-list-item class="hoverList1" to="/viewbooking">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/viewBooking_icon.png')" width="22px" class="iconColor" />
                        </div>
                        <span class="ps-1 text-color" style="font-size: 15px;">Find My Trip</span>
                      </div>
                    </v-list-item> -->
                    <v-list-item class="hoverList1" to="/contactPage">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/reqform_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <a class="ps-1 text-color" href="/contactpage" style="font-size: 14px;">Request Form</a>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </li>
              <li class="nav-item dropdown d-flex justify-md-end justify-center align-center" ref="dropdown" style="cursor:pointer;">
                <div class="d-flex align-center">
                  <!-- <div>
                    <v-img :src="require('@/assets/icons/viewBooking_icon.png')" width="22px" class="iconColor" />
                  </div> -->
                  <!-- <router-link to="/viewbooking" style="text-decoration:none;"></router-link> -->
                    <span class="ps-1 text-color fw-bold" style="font-size: 15px;" @click="toggleForm()">My Trips</span>
                  </div>
                  <div v-if="showForm" class="dropdown-form mt-2">
                    <v-form v-model="valid" ref="form" @submit.prevent="bookinglist">
                      <div class="pre-card">
                        <v-card style="width: 300px; padding: 25px; height: 255px">
                          <div class="col-12">
                            <v-text-field
                              label="Booking ID"
                              v-model="bookid"
                              :rules="[(v) => !!v || 'Enter the Booking ID']"
                              variant="outlined"
                            ></v-text-field>
                          </div>

                          <div class="col-12">
                            <v-text-field
                              label="Last Name"
                              :rules="[(v) => !!v || 'Enter the Last Name']"
                              v-model="lastname"
                              variant="outlined"
                              @input="capitalizeLastName"
                            ></v-text-field>
                          </div>

                          <div class="col-12">
                            <v-btn
                              type="submit"
                              width="100%"
                              style="height: 45px !important;
                              background:linear-gradient(0deg, #930253 0%, #ba0e6f 100%);
                              color:white;"
                              >Submit</v-btn>
                          </div>
                        </v-card>
                      </div>
                    </v-form>
                  </div>
              </li>

              <li v-if="!headerMenus.includes('accounts')" class="nav-item dropdown d-flex justify-end align-center">
                <v-menu v-model="isMenuAccount" location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-card class="shadow-none bg-transparent d-flex accountHead" v-bind="props" style="cursor: pointer">
                      <div class="d-flex align-center">
                        <div>
                          <!-- <v-img :src="require('@/assets/icons/account_icon.png')" width="22px" class="iconColor"/> -->
                        </div>
                        <!-- <span class="ps-1 f-size-15 fw-600" :class="this.userName ? 'accountUser' : 'accountText'" 
                          style="color: white">{{ this.userName ? this.userName : "Account" }}</span> -->
                      </div>
                      <v-list-item class="hoverList1" to="/login" v-if="!this.userName" @click="showForm = false">
                      <div class="d-flex align-center">
                        <div>
                          <!-- <v-img :src="require('@/assets/icons/userlogin_icon.png')" width="18px" class="iconColor"/> -->
                        </div>
                        <span class="ps-1 text-color f-size-15 fw-bold">Sign In</span>
                      </div>
                    </v-list-item>

                      <v-list-item-icon v-if="this.userName">
                        <span>
                          <v-icon size="30" :class="{ 'rotate-icon': isMenuAccount }" class="textColor">mdi-menu-down</v-icon>
                        </span>
                      </v-list-item-icon>
                    </v-card>


                  </template>
                  <v-list v-if="this.userName" style="cursor: pointer;background-color:#161b31;">
                    <v-list-item class="hoverList1" to="/myprofile" v-if="this.userName">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/myprofile_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 f-size-15">My Profile</span>
                      </div>
                    </v-list-item>
                    <!-- <v-list-item class="hoverList1" to="/login" v-if="!this.userName">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/userlogin_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 text-color f-size-15">Login</span>
                      </div>
                    </v-list-item> -->
                    <!-- <v-list-item class="hoverList1" to="/register" v-if="!this.userName">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/userregister_icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 f-size-15 text-color">Register</span>
                      </div>
                    </v-list-item> -->
                    <v-list-item class="hoverList1" to="/mybooking" v-if="this.userName && !this.headerMenus.includes('mybookings')">
                      <div class="d-flex align-center">
                        <div>
                          <v-img :src="require('@/assets/icons/myBooking_icon.png')" width="18px" class="iconColor" />
                        </div>
                        <span class="ps-1 f-size-15">My Bookings</span>
                      </div>
                    </v-list-item>
                    <v-list-item class="hoverList1" v-if="this.userName">
                      <div class="d-flex align-center" @click="deleteItem()">
                        <div>
                          <v-img :src="require('@/assets/icons/logout_Icon.png')" width="18px" class="iconColor"/>
                        </div>
                        <span class="ps-1 f-size-15">Logout</span>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </header>

  <div v-if="loginform">
    <loginCom :isVisible="loginform" @close="closeLogin()" @switch-to-register="switchToRegister"></loginCom>
  </div>
  <div v-if="registerform">
    <registerCom :isRegister="registerform" @close="closeRegister()" @switch-to-login="switchToLogin"></registerCom>
  </div>
</template>


<script>
import loginCom from "@/components/loginPage.vue";
import registerCom from "@/components/registerPage.vue";
// import { Collapse } from "bootstrap";
import CryptoJS from "crypto-js";

import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";


export default {
  components: {
    registerCom,
    loginCom,
  },
  emits :{
    localeChanged: null,
    },
  data() {
    return {
      loginform: false,
      registerform: false,
      selectedCountry: null,
      isSticky: false,
      conDetails: true,
      menuData: "",
      isCollapsed: true,

      isMenuCurrency: false,
      isMenulanguage: false,
      isMenuHelp: false,
      isMenuAccount: false,

      portCurrency: "EN US$",
      // portCurrencyLogo: require("@/assets/icons/US.svg"),

      hostName: "",
      portalUrl: "",
      userqueryIso:"",

      userDetails: true,
      userProfile: false,
      userEmail: "",
      userName: "",
      portalLogo: "",
      emailPortal: "",
      phonePortal: "",
      countryOptions: [],
      languageOptions: [],
      languagePortal: "",
      currencyPortal: "",
      countyIsocode: "",
      siteContentData: "",
      // languageData:"",
      changedLang: '',

      user: {
        initials: "",
        // fullName: 'John Doe',
        email: "",
      },

      languages: [
        { flag: "gb", language: "CA-en", title: "English (UK)" },
        { flag: "es", language: "CA-es", title: "Spanish (Spain)" },
        // { flag: 'fr', language: 'fr', title: 'French (France)' },
        // { flag: 'de', language: 'de', title: 'German (Germany)' },
        // { flag: 'it', language: 'it', title: 'Italian (Italy)' },
        // { flag: 'jp', language: 'ja', title: 'Japanese (Japan)' },
        // { flag: 'cn', language: 'zh', title: 'Chinese (China)' },
        // { flag: 'ca', language: 'en', title: 'English (Canada)' },
        // { flag: 'au', language: 'en', title: 'English (Australia)' },
        // { flag: 'za', language: 'en', title: 'English (South Africa)' },
        // { flag: 'us', language: 'en', title: 'English (USA)' },
        // { flag: 'gb', language: 'en', title: 'English (UK)' },
      ],

      displayLanguage: "",
      dropdownLanguages: [],

      headerMenus: [],
      // menuEmail:"",
      // menuPhone:"",
      bookid: "",
      lastname: "",
      showForm:false,
    };
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
    },
    capitalizeLastName() {
      this.lastname =
        this.lastname.charAt(0).toUpperCase() + this.lastname.slice(1);
    },
    bookinglist() {
      if (this.valid) {
        this.overlay = true;
        let obj = {
              booking_Id:this.bookid,
              last_name:this.lastname
            }
            let booking_details = JSON.stringify(obj)
        setTimeout(() => {
          this.dialog3 = true;
          this.overlay = false;
            this.$router.push({ path: "/bookingView", query: { booking_id: booking_details }, })
        },2000)
      }
    },
    showLoginForm() {
      this.loginform = true;
      this.registerform = false;
    },
    showRegisterForm() {
      this.registerform = true;
      this.loginform = false;
    },

    switchToLogin() {
      this.loginform = true;
      this.registerform = false;
    },
    switchToRegister() {
      this.registerform = true;
      this.loginform = false;
    },

    // getLanguage(getLang){
    //   console.log(getLang,'getLanggetLanggetLanggetLang')
    //   let data = getLang !== languages.display
    //   return data ? true : false
    // },

    // displayLanguage(){
    //   return languageOptions[0].code.toUpperCase()
    // },

    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed;
      this.showForm = !this.showForm
    },

    handleOutsideClick(event) {
      // const navbar = this.$refs.navbarCollapse;
      // const button = event.target.closest(".navbar-toggler");

      // if (!navbar.contains(event.target) && !button && !this.isCollapsed) {
      //   if (!this.isCollapsed) {
      //     this.toggleNavbar();
      //   }
      // }
      if (this.showForm && this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showForm = false;
      }
      // this.showForm = false;
      // this.toggleForm()
    },

    changeLocale(locale) {
      const reloadLang = setInterval(() => {
        // location.reload();
      }, 150);

      // this.languages.forEach(v=>{
      // console.log(v.language.split('-')[1],'v.language.split('-')[1]v.language.split('-')[1]')
      // if(v.language.split('-')[1] == locale){
      // const countryCode = this.countryOptions[0].country_code;

      if (reloadLang) {
        console.log(reloadLang, "reloadLangreloadLang");
        const newLocale = `${this.countyIsocode}-${locale}`;
        console.log("Changing locale to", newLocale);
        // this.$i18n.locale = newLocale;

        this.changedLang = newLocale
        this.$emit('localeChanged', this.changedLang);

        localStorage.setItem("defaultlang", newLocale);
        // this.$i18n.fallbackLocale = v.language;
        console.log("Current locale:", this.$i18n);
        // }
        // })
        this.displayLanguage = locale;
        this.updateDropdownLanguages();

        // this.localeLanguage();
      }
    },

    updateDropdownLanguages() {
      console.log(this.languageOptions, "languageOptionslanguage", this.displayLanguage);
      this.dropdownLanguages = this.languageOptions.filter((lang) => {
        if (lang.code !== this.displayLanguage) {
          return lang.code;
        }
      });
      console.log(this.displayLanguage, "dropdownLanguagesdropdownLanguages");
    },

    displayedLang() {
      let getlocalIso = this.$i18n.locale;

      let getsetlang = getlocalIso.split("-")[1];
      this.displayLanguage = getsetlang;
      // let datalang = this.localeLanguage();
      // let getlocalIso = datalang;
      // this.$i18n.locale = datalang;
      // let getlocalIso = this.$i18n.locale;
      console.log(this.displayLanguage, "i18ni18ni18ni18ni18n");
      this.updateDropdownLanguages();
      console.log(this.$i18n.locale, "getegeteegtegete...7");
    },

    localeLanguage() {
      const storedLocale = localStorage.getItem("defaultlang");
      const storedSetLang = localStorage.getItem("setlang");

      let getlocalIso = "";
      let getlocalLang = "";
      let getsetIso = "";
      let getsetlang = "";
      // let savedLanguage = "";

      if (storedLocale) {
        getlocalIso = storedLocale.split("-")[0];
        getlocalLang = storedLocale.split("-")[1];
      }
      if (storedSetLang) {
        getsetIso = storedSetLang.split("-")[0];
        getsetlang = storedSetLang.split("-")[1];
      }

      if (storedSetLang && storedLocale) {
        console.log("Check...1");
        if (storedLocale == storedSetLang) {
          console.log("Check...2");

          return storedSetLang;
          // this.i18n.locale = storedSetLang;
        } else if (storedLocale !== storedSetLang) {
          console.log(getlocalIso, getsetIso, "Check...3", getlocalLang, getsetlang);
          if (getlocalIso !== getsetIso && getlocalLang !== getsetlang) {
            localStorage.removeItem("defaultlang");
            console.log("Check...4");
            return storedSetLang;
            // this.i18n.locale = storedSetLang;
          } else if (getlocalIso == getsetIso && getlocalLang !== getsetlang) {
            console.log("Check...5");

            return storedLocale;
            // this.i18n.locale = storedLocale;
          }
        }
      } else if (storedSetLang) {
        console.log("Check...6");

        return storedSetLang;
        // this.i18n.locale = storedSetLang;
      } else if (storedLocale) {
        console.log("Check...7");

        return storedLocale;
        // this.i18n.locale = storedLocale;
      } else {
        console.log("Check...8");

        return `${this.countyIsocode}-${this.getLanguage[0].code}`;
        // this.i18n.locale = `${this.countyIsocode}-${this.getLanguage[0].code}`;
      }
    },

    toggleDropdown(dropdownName) {
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },

    toggleTawkToChat() {
      if (window.Tawk_API) {
        window.Tawk_API.toggle();
      }
    },

    portalLink(countryOptions) {
      return countryOptions[0].portal_url;
    },
    portallogo(countryOptions) {
      return countryOptions[0].flag_logo;
    },

    handleScroll() {
      this.isSticky = window.scrollY > 90;
    },
    signIn() {
      // this.loginform = true;
      this.loginform = !this.loginform;
      // this.registerform = false;
    },
    signUp() {
      // this.registerform = true;
      this.registerform = true;
      // this.registerform = false;
    },

    closeLogin() {
      this.loginform = false;
      console.log(this.loginform, "4444444");
    },
    closeRegister() {
      this.registerform = false;
      console.log(this.registerform, "registerformregisterform");
    },

    getUser() {
      let userData = JSON.parse(localStorage.getItem("value"));
      // console.log(userData, "user....");
      if (userData) {
        this.userDetails = false;
        this.userProfile = true;
      } else {
        this.userDetails = true;
        this.userProfile = false;
      }
    },
    booking() {
      this.$router.push("/dashboard");
    },
    deleteItem() {
      localStorage.removeItem("value");
      localStorage.removeItem("loginuser");
      localStorage.removeItem("loginDatas");
      setInterval(() => {
        location.reload();
      }, 500);
      this.userDetails = true;
      this.userProfile = false;
      // this.$router.push('/');
    },

    getLoginDatas() {
      JSON.parse(localStorage.getItem("loginDatas"));
    },
    getlogo(data) {
      console.log(data, "duifuisddsddjik");
    },

    getConfigFunc() {
      // Parse the decrypted data as JSON
      const getConfigData = getConfigDataFromLocalStorage();
      console.log(getConfigData, "head...1");
      // let getConfigData = this.$store.state.data

      if (getConfigData) {
        this.menuData = getConfigData.payload.portal_configuration.menus.enabled.header;
        console.log(this.menuData,getConfigData.payload.portal_configuration.menus.enabled.header,'headerMenusheaderMenus..1')

        // let Menus = "";
        // Menus = getConfigData.payload.portal_configuration.menus.enabled.header;
        // Menus = "country, language, email, phone";
        // console.log(this.menuData.includes('viewbookings'),'MenusMenus3333')
        this.headerMenus = this.menuData.split(", ");
        console.log(this.headerMenus,'headerMenusheadermenus')

        this.portalUrl = getConfigData.payload.portal_configuration.portal_url;
        this.portalLogo = getConfigData.payload.portal_configuration.logo_path;
        this.phonePortal = getConfigData.payload.portal_configuration.phone;
        this.emailPortal = getConfigData.payload.portal_configuration.email;
        this.currencyData = getConfigData.payload.portal_configuration.currency;
        this.countyIsocode = getConfigData.payload.portal_configuration.country.iso_code;

        // this.portalLanguage = 'ENG'
        this.portalLanguage = getConfigData.payload.portal_configuration.language;

        this.countryOptions = getConfigData.payload.portal_configuration.country_options;

        this.languageOptions = getConfigData.payload.portal_configuration.languages;

        this.displayLanguage = this.languageOptions[0].code

        console.log(this.languageData,'siteContentDatasiteContentDatasiteContentData')

        this.siteContentData =
          getConfigData.payload.portal_configuration.site_content_data;

        this.updateDropdownLanguages();

        this.countryOptions.forEach((v) => {
          if (v.currency == this.currencyData.display) {
            this.display_flagLogo = v.flag_logo;
            this.currencyData.display = v.currency;
          }
        });
      }
    },

    decyptedquery(){
      const getrouteiso = this.$route.query ? (this.$route.query.usercountry || null ) : null;
      let secretqueryKey = "secretquery";
      if(getrouteiso){     
        const decodedEncrypted = getrouteiso ? atob(getrouteiso) : null;
        const decrypted = CryptoJS.AES.decrypt(decodedEncrypted, secretqueryKey).toString(CryptoJS.enc.Utf8);
        let usercountryIso = decrypted ? JSON.parse(decrypted) : null;
        this.userqueryIso = usercountryIso;
      }
    }
  },

  // watch: {

  //   "$route.path": {
  //     immediate: true,
  //     handler(newValue) {
  //       this.isCollapsed = true;
  //       if (newValue === "/confirmBook" || newValue === "/bookingView") {
  //         // this.langDisabled = true; 
  //         this.countryDisabled = true; 
  //       } else {
  //         // this.langDisabled = false; 
  //         this.countryDisabled = false;
  //       }
  //       // console.log(newValue, '4545');
  //     },
  //   },
  // },

  computed:{
    currentCountry() {
      return this.countryOptions.find((country) => country.country_code === this.countyIsocode) || null;
    },
    filteredCountryOptions() {
      return this.countryOptions.filter((country) => country.country_code !== this.countyIsocode);
    },
    sortedLanguageOptions() {
      const currentLanguage = this.languageOptions.find(lang => lang.code === this.displayLanguage);
      let remainingLanguages = [...this.languageOptions].filter(lang => lang.code !== this.displayLanguage);
      remainingLanguages.sort((a, b) => a.name.localeCompare(b.name));
      if (currentLanguage) {
        remainingLanguages.unshift(currentLanguage);
      }
      return remainingLanguages;
    },
  },

  created() {
    this.getConfigFunc();
    let $useresult = JSON.parse(localStorage.getItem("loginuser"));
    // console.log($useresult, '$useresult $useresult ')
    if ($useresult) {
      this.userEmail = $useresult.user.email;
      this.userName = $useresult.user.first_name || $useresult.user.name;
      // if(this.userName){
      //   this.$router.push('/');
      // }
      console.log($useresult, "useresultuseresult");
      console.log(this.userEmail, this.userName, "adsasfasdas");
    }

    // this.localeLanguage();
    // this.displayedLang();
    // this.localeLanguage();
  },

  mounted() {
    // this.navbarCollapse = new Collapse(this.$refs.navbarCollapse, {
    //   toggle: false,
    // });
    // Add a document click listener to detect outside clicks
    document.addEventListener("click", this.handleOutsideClick);

    window.addEventListener("scroll", this.handleScroll);
    this.getUser();
    this.getLoginDatas();
    this.decyptedquery();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);

    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style scoped>

.fw-600{
  font-weight: 600;
}
.fw-500{
  font-weight: 500;
}
.fw-400{
  font-weight: 400;
}

.f-size-16{
  font-size: 16px;
}
.f-size-15{
  font-size: 15px;
}
.f-size-14{
  font-size: 14px;
}
.f-size-12{
  font-size: 12px;
}


/* navbar */
.logo {
  width: 180px;
}

.portal_logo {
  width: 130px;
  height: 65px;
  cursor: pointer;
}
.portal_logo1 {
  width: 30px;
  height: 30px;
  cursor: pointer;
  margin-left: 50px;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #1f2746 !important;
  z-index: 2;
  animation: fadeInDown 0.6s ease-in-out 0s 1 normal none running;
  transition: 0.6s;
  box-shadow: 0px 0px 20px 0px black;

  /* Add any other styles you need for the sticky header */
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-link {
  font-weight: var(--font-600);
  font-size: var(--font-18);
}

.nav-link.active {
  color: var(--primary-color) !important;
}

.btn-white {
  background-color: white;
  padding: 10px 25px;
  border-radius: 15px;
}

.btn-text {
  color: var(--primary-color);
  font-weight: var(--font-400);
}

.v-select .v-field.v-field {
  cursor: pointer;
  box-shadow: none;
}

/* .v-btn__content {
  color: #FF5400;
  font-size: 17px;
  font-weight: 600;
  text-transform: capitalize;
} */

.bgimg {
  /* background-image: url("@/assets/icons/CA.svg"); */
  background-repeat: no-repeat;
  background-position: center;
}

.book-ticket {
  /* color: #FF5400; */
  background-color: #f0f0f0;
}

.btn-box {
  background-color: transparent;
  margin: 5px;
  padding: 2px;
  box-shadow: none;
  /* color: white; */
}

.btn-active {
  background-color: blueviolet;
  /* color: white; */
}

.v-checkbox .v-input__details {
  display: none;
}

.dropdown-toggle::after {
  display: none !important;
}

.navbar-toggler {
  border: none !important;
}

/* .navbar-collapse {
  transition: max-height 1s ease, opacity 1s ease;
  overflow: hidden;
}

.navbar-collapse.show {
  max-height: 500px; 
  opacity: 1;
}

.navbar-collapse:not(.show) {
  max-height: auto;
  opacity: 1; 
} */

.dropdown-toggle {
  width: 50px;
  height: 30px;
  white-space: nowrap;
  border: 1px solid !important;
}

/* .v-app-bar {
  height: 100px;
  background-image: url('../assets/flight.jpg');
  background-size: 100% 100%;
} */

/* .btn-box,
.pipe {
  color: white !important;
} */

.contact-box {
  box-shadow: none;
  background: none;
  border: 1px solid lightgray;
}

.contact-box span {
  font-size: 15px;
}

/* .hoverList1:hover {
  color: #42d4ec;
  background: #1f2746;
}
.hoverList1:hover .text-color{
  color:#42d4ec;
} */
.text-color{
  color:white;
}
.text-color:hover{
  color:#22a9bf;
}
/* .hoverList1:hover .iconColor{
  filter: brightness(0) saturate(100%) invert(75%) sepia(82%) saturate(1004%) hue-rotate(153deg) brightness(95%) contrast(94%);
} */

.booking {
  color: #212529;
  padding-bottom: 2px;
  cursor: pointer;
}

.booking:hover {
  color: #212529;
  border-bottom: 3px solid orange;
  padding-bottom: 2px;
  cursor: pointer;
}

.booking-active {
  color: #212529;
  border-bottom: 3px solid orange;
  padding-bottom: 2px;
  cursor: pointer;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.rotate {
  animation: spin 0.5s forwards;
}

.navbar .container-fluid.setSize {
  width: fit-content !important;
  /* width: auto; */
}

.contact-section-mobile1 {
  display: none !important;
}

.disabledLang{
  pointer-events: none !important;
}

.disabledLang:hover{
  background-color: #f4f4f4;
}



@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
  }
}

/* .currency-text {
    display: block;
  } */

.booking {
  color: #212529;
  padding-bottom: 2px;
  cursor: pointer;
}
.textColor{
  color:white;
}
.textColor:hover{
  color:#22a9bf;
}
.iconColor{
  filter:brightness(0) invert(1) ;
}

@media only screen and (min-width: 992px) {
  .contact-section-mobile {
    display: none !important;
  }

  .contact-section-large {
    display: flex !important;
  }

  .contact-section-collapse {
    display: none !important;
  }

  .accountHead .accountUser,.v-list-item-icon{
    display: block;
  }
  .accountHead .accountText{
    display: none;
  }
}

@media only screen and (max-width: 991px) {
  .navbar .container-fluid.setSize {
    width: 100% !important;
    top: 100%;
    right: 0;
    position: absolute;
    background: #161b31;
    width: fit-content !important;
    border-radius: 0px 0px 6px 6px;
    box-shadow: 0px 1px 2px 0px black;
    z-index: 999;
  }

  .contact-section-mobile {
    display: flex !important;
  }

  .contact-section-large {
    display: none !important;
  }

  .contact-section-collapse {
    display: block !important;
  }

  .accountHead .accountUser,.v-list-item-icon{
      display: block;
    }
  .accountHead .accountText{
    display: block;
  }
}

@media only screen and (max-width: 480px) {
  .myBooking {
    display: none !important;
  }

  .portal_logo {
    width: 150px;
    height: 55px;
    cursor: pointer;
  }

  .dropdown-toggle {
    width: 40px;
    height: 28px;
    padding: 0 !important;
  }
  /* .textColor{
    color:black;
  }
  .iconColor{
    filter:none !important;
  } */

  /* .navbar .container-fluid.setSize {
    width: 100% !important;
    top: 100%;
    right: 0;
    position: absolute;
    background: white;
    width: fit-content !important;
    border-radius: 0px 0px 6px 6px;
  } */

  .iconDiv {
    border: 1px solid black;
  }

  .currency-text {
    display: none;
  }
  .mob_Hd
  {
    display: block !important;
  }
}

@media screen and (max-width: 430px) {
  .contact-section-mobile1 {
    display: block !important;
  }

  .navbar-toggler:focus {
    box-shadow: none !important;
  }

  .dropdown-toggle {
    border: 0px !important;
  }

  /* .emailhover:hover{
  background-color:aquamarine;
} */
}

.dropdown-toggle {
  border: 0px !important;
}
:deep(.v-menu > .v-overlay__content > .v-list){
  background-color:black !important;
}
.dropdown-form {
  position: absolute;
  z-index: 10;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  top:62px;
}
.v-card__overlay{
  background-color:rgb(31 39 70) !important;
  opacity:0 !important
}
:deep(.v-list-item--variant-text .v-list-item__overlay){
  background:rgb(31 39 70) !important;
}
.v-card:hover .textColor{
  color:#22a9bf;
}
.offblue{
  background-color: #1f2746;
}

.accordion-item{
  background-color: #1f2746;
}

.accordion-button1:not(.collapsed)::after {
    background-image: none !important;
    /* transform: var(--bs-accordion-btn-icon-transform); */
}

.accordion-button:focus
{
  box-shadow: none !important;
  background-color: #1f2746 !important;
}

.accordion-button
{
  background-color: #1f2746;
  color: white !important;
  border: none !important;
  padding: 0px 0px 10px 0px !important;
}

.accordion-button::after {
    background-image: var(--bs-accordion-btn-icon);
    filter: brightness(0) invert(1);
    /* background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition); */
}
.accordion-flush > .accordion-item {
    border-bottom: 0 !important;
}

.offcanvas-header .btn-close{
  margin-right: 15px;
  filter: brightness(0) invert(1);
}

.offcanvas-title{
  margin-left: -25px;
}

.accr_t{
  margin-left: 21px;
  color: white;
  margin-top: 10px;
  border-bottom: 1px dotted white !important;
  padding: 0px 30px 10px 0px;
  margin-right: 30px;
}

.mob_Hd{
  display: none;
}
.accordion-header
{
  border-bottom: 1px dotted white !important;
    margin: 0px 30px 10px 22px;
    background-color: #1f2746;
}

.offcanvas
{
  padding: 5px;
}

.accordion {
    --bs-accordion-active-bg: none !important;
}

.bg-transparent {
    color: transparent !important;
    background-color: transparent !important;
}

@supports selector(:focus-visible) {
    .v-list-item::after {
        /* pointer-events: none; */
        border: none !important;
        /* border-radius: 4px; */
        /* opacity: 0; */
        /* transition: opacity 0.2sease-in-out; */
    }
}

.v-card--variant-elevated, .v-card--variant-flat {
    background: rgb(var(--v-theme-surface));
    color: rgb(31 39 70) !important;
}
</style>
